import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cookie from 'react-cookie';

import { applyFilters, resetFilters } from '../actions';
import ConsultQueueFilters from './consult-queue-filters';

import { FILTERS, DEFAULT_SPECIALTY } from '../constants';

export class ConsultQueueFiltersContainer extends Component {
  fetchInitialValues = () => {
    let initialValues = {
        service_specialty: cookie.load('service_specialty') || DEFAULT_SPECIALTY,
        service_specialty_feature: cookie.load('service_specialty_feature')
      };
    FILTERS.map(filter => filter['cookieName']).forEach(cookieName => initialValues[cookieName] = cookie.load(cookieName));
    return initialValues;
  }
  
  render() {
    const { filters, applyFilters, resetFilters } = this.props;
    return (
      <ConsultQueueFilters
        filters={filters}
        initialValues={this.fetchInitialValues()}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
      />
    );
  }
}

const mapDispatchToProps = {
  applyFilters,
  resetFilters
};

ConsultQueueFiltersContainer.propTypes = {
  filters: PropTypes.shape({
    communication_methods: PropTypes.array,
    statuses: PropTypes.array,
    providers: PropTypes.array,
    cancellation_reasons: PropTypes.array,
    countries: PropTypes.array,
    states_by_country: PropTypes.object,
    service_specialties: PropTypes.array,
    consultation_origins: PropTypes.array,
    business_labels: PropTypes.array
  }),
  applyFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired
};

export default connect(
  null,
  mapDispatchToProps
)(ConsultQueueFiltersContainer);
